import type { ReadonlyDate } from '.'

export const isReadonlyDate = (date: unknown): date is ReadonlyDate => date instanceof Date
